import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


import Swal from 'sweetalert2';
import { CarritoModel } from '../../Models/carritoModel';
import { LoginService } from '../../Services/login.service';
import { CarritoService } from '../../Services/carrito.service';
import { MessagesService } from '../../Services/messages.service';
import { ClienteService } from '@services/cliente.service';
import { safeLocalStorage, safeSessionStorage } from '@shared/safe-web-storage';

const localStorage = safeLocalStorage;
const sessionStorage = safeSessionStorage;

@Component({
    selector: 'app-registro',
    templateUrl: './registro.component.html',
    styleUrls: ['./registro.component.css'],
    standalone: false
})
export class RegistroComponent implements OnInit {
  public  user!: SocialUser;

  public logoPath: string = './Public/Img/LogoClave.png';
  public formGroup: UntypedFormGroup;
  public formLogin: UntypedFormGroup;
  public carrito:CarritoModel[] = [];

  passwordFieldType: string = 'password';
  private readonly namePattern = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s.'-]{2,80}$/;
  private readonly passwordPattern = /^(?=.*[A-Za-z])(?=.*\d).{8,72}$/;
  private readonly safeNamePattern = /^[a-zA-Z\u00C0-\u017F\s.'-]{2,80}$/;

  constructor(
     private formBuilder:UntypedFormBuilder, private loginService:LoginService,
    private modal:NgbModal,public router: Router,private authService: SocialAuthService,
    private carServices:CarritoService, private msg:MessagesService,private clienteService:ClienteService) {

    this.formGroup = this.formBuilder.group({});
    this.formLogin = this.formBuilder.group({});
   }

    // ver password
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    }

   private builderFormRegistro(){
    const dateLength = 10;
    const minPassLength = 8;
    const today = new Date().toISOString().substring(0, dateLength);
    const name = '';
      this.formGroup = this.formBuilder.group({
        registeredOn: today,
        modo:"directo",
        name: [name.toLowerCase(), [Validators.required, Validators.pattern(this.safeNamePattern)]],
        email: ['', [
          Validators.required, Validators.email
        ]],
        password: ['', [
          Validators.required, Validators.minLength(minPassLength), Validators.maxLength(72), Validators.pattern(this.passwordPattern)
        ]],
        confirmpassword: ['', [
          Validators.required, Validators.minLength(minPassLength), Validators.maxLength(72)
        ]]
      })
   }

   private builderFormLogin(){
    const dateLength = 10;
    const minPassLength = 8;
    const today = new Date().toISOString().substring(0, dateLength);
    const name = '';
      this.formLogin = this.formBuilder.group({
        email: ['', [
          Validators.required, Validators.email
        ]],
        password: ['', [
          Validators.required, Validators.minLength(minPassLength), Validators.maxLength(72)
        ]]

      })
   }
   async Login(){
    this.formLogin.patchValue({
      email: String(this.formLogin.get('email')?.value ?? '').trim().toLowerCase()
    });
    if (this.formLogin.invalid) {
      this.formLogin.markAllAsTouched();
      return;
    }

    let response:any;
    response = await this.loginService.IniciaSession(this.formLogin.value);
    if (response[0].Correcto == 1   ){

      this.msg.MensajeConfirm(response[0].Mensaje,'Hola',false,'Ok',"No",'success')
      .then((result:any) => {
          if (result.value) {
            window.location.reload();
          }
          });

      const clientesConsultados = await this.clienteService.ConsultaClientes("", response[0].Mail) as any[];

      sessionStorage.setItem('precioCliente', clientesConsultados[0].PrecioCliente);
      sessionStorage.setItem('IdUsuario', response[0].IdUsr);
      sessionStorage.setItem('Nombre', response[0].Nombre);
      sessionStorage.setItem('Mail', response[0].Mail);
      sessionStorage.setItem('Modo', response[0].Modo);
    }
    else if (response[0].Correcto == 2   )
      this.msg.mensajeRapido(response[0].Mensaje,'Atención','info');
    else
      this.msg.mensajeRapido(response[0].Mensaje,'Atención','error');
  }

  async Registro() {
    this.formGroup.patchValue({
      name: String(this.formGroup.get('name')?.value ?? '').trim(),
      email: String(this.formGroup.get('email')?.value ?? '').trim().toLowerCase()
    });
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    if (this.formGroup.get('password')?.value !== this.formGroup.get('confirmpassword')?.value) {
      this.msg.mensajeRapido('Las contraseñas no coinciden.', 'Atención', 'warning');
      return;
    }

    let response:any;
    response = await this.loginService.Registrar(this.formGroup.value);
    if (response != 301 ){
        if (response[0].Correcto == 1 ){
          this.msg.MensajeConfirm(response[0].Mensaje,'Hola',false,'Ok','No','success')
          .then((result:any) => {
               if (result.value) {
                 window.location.reload();
               }
              });
        }
        else if (response[0].Correcto == 2 ){
          this.msg.mensajeRapido(response[0].Mensaje,'Atención','success');

          sessionStorage.setItem('IdUsuario', response[0].IdUsuario)
          sessionStorage.setItem('Nombre', response[0].Nombre)
          sessionStorage.setItem('Mail', response[0].Mail)
          sessionStorage.setItem('Modo', response[0].Modo);

          this.BuscacarritoLocalyGuarda(response[0].IdUsuario);
        }
        else
        {
          this.msg.mensajeRapido(response[0].Mensaje,'Atención','error');
        }
    }
    else
    {
      this.msg.mensajeRapido('Ocurrió un error al momento de verificar tu correo','Atención','error');
    }
 }

  private generarPasswordTemporal(): string {
    const bytes = new Uint8Array(24);
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
    }
    const token = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `Clv-${token}9a`;
  }

 async BuscacarritoLocalyGuarda (idUsuario:any) {
    // ¿Existe un carrito previo guardado en LocalStorage?
    if (localStorage.getItem('carrito') !== null) {
        // Carga la información
        this.carrito = JSON.parse(localStorage.getItem('carrito')|| "");
        for(let child of this.carrito){
          let response;
          response = await this.carServices.addCarProd([{IdUsuario:idUsuario,Cantidad:child.Cantidad,IdProductoModelo:child.IdProductoModelo,Precio:child.Precio}]);
        }
        localStorage.removeItem("carrito");
    }
    window.location.reload();
}

  public getError(controlName: string): string {
    let error = '';
    let control = this.formGroup!.get(controlName) || null;
    if (control!.touched && control!.errors != null) {
      error = JSON.stringify(control!.errors);

    }
    return error;
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

   ngOnInit() {
    let response;
    this.builderFormRegistro();
    this.builderFormLogin();
    this.authService.authState.subscribe((user: any) => {
      this.user = user;
      if (user != null){
        const passwordTemporal = this.generarPasswordTemporal();
        this.formGroup.setValue({
          registeredOn: "",
          modo: user.provider,
          name: user.name,
          email: user.email,
          password: passwordTemporal,
          confirmpassword: passwordTemporal
        })
        this.Registro();
      }
    });


  }

  goToReset(){
      this.modal.dismissAll() // ✅ Cierra modal
    this.router.navigate(['/recuperar-password']);
  }
}
